import {useState, useMemo, useEffect} from 'react'
import {createFileRoute} from '@tanstack/react-router'
import {IconButton, Drawer} from '@mui/material'
import {LuChevronDown} from 'react-icons/lu'
import {SortState} from '@/components/ui/Table'
import {useAppContext} from '@/context/AppContext'
import {TransactionsFilters} from '@/components/transactions/TransactionsFilters'
import {TransactionsTable} from '@/components/transactions/TransactionsTable'
import {TransactionDetailsModal} from '@/components/transactions/TransactionDetailsModal'
import {
  TransactionRow,
  TransactionType
} from '@/components/transactions/transactionsTable.data'
import stylesCommon from '@/common/commonStyles.module.scss'
import styles from './index.module.scss'
import filterFunnelIcon from '@/assets/icons/filter-funnel.svg?url'
import xCloseIcon from '@/assets/icons/x-close.svg?url'
import {useAuthQuery} from "@/hooks/useAuthApi.ts";
import {useGetTransactionsQuery} from "@/api/endpoints/transactions.ts";
import {TransactionCardProps} from "@/common/types/api/wallet.types.api.ts";
import {tokenBalanceToUi} from "@/common/functions.ts";
import BN from "bn.js";


function dateFormat(strUtcDate: string) {
  const date = new Date(strUtcDate);
  const utcDay = String(date.getUTCDate()).padStart(2, "0");
  const utcMonth = String(date.getUTCMonth() + 1).padStart(2, "0");
  const utcYear = String(date.getUTCFullYear());
  const utcHours = String(date.getUTCHours()).padStart(2, "0");
  const utcMinutes = String(date.getUTCMinutes()).padStart(2, "0");

  const formattedUTC = `${utcDay}.${utcMonth}.${utcYear} ${utcHours}:${utcMinutes}`;

  return formattedUTC
}


export const Route = createFileRoute('/_mainLayout/transactions/')({
  component: RouteComponent,
})

function parseDateStr(d: string): Date {
  const [date, time] = d.split(' ')
  const [dd, mm, yyyy] = date.split('.')
  return new Date(`${yyyy}-${mm}-${dd}T${time}Z`)
}

function RouteComponent() {
  const {isMobile} = useAppContext()
  const [dateFrom, setDateFrom] = useState<Date | undefined>(undefined)
  const [dateTo, setDateTo] = useState<Date | undefined>(undefined)
  const [dateFromUTC, setDateFromUTC] = useState<Date | undefined>(undefined)
  const [dateToUTC, setDateToUTC] = useState<Date | undefined>(undefined)



  const [type, setType] = useState<TransactionType | ''>('')
  const [currency, setCurrency] = useState('')
  const [sort, setSort] = useState<SortState>(null)
  const [selectedTransaction, setSelectedTransaction] = useState<TransactionRow | null>(null)
  const [showFilters, setShowFilters] = useState(false)
  const [loadedPages, setLoadedPages] = useState(0)


  const [txList, setTxList] = useState<TransactionRow[]>([])

  const {data, isSuccess: txQueryisSuccess} = useAuthQuery(useGetTransactionsQuery)

  useEffect(() => {
    if (data) {
      const tmp: TransactionRow[] = data.map(item => ({
        type: item.Type as TransactionType,
        dateTime: dateFormat(item.TxAt),
        info: item.Info,
        total: item.Type == 'Claim pool' ? tokenBalanceToUi(new BN(item.Amount),' USDC',3,6,false) :item.Amount + ' ' + item.Token,
        // status: item.Status,
        txHash: item.Signature,
        txId: item.Signature,
        id: item.Signature,
        amount: item.Amount +' ' + item.Token,
        amountStyle: 'positive',
        status: 'done',
        network: 'SOL',



      }));
      setTxList(tmp);
    }

  }, [data]);


  const [allPages, setAllPages] = useState<TransactionRow[][]>([])

  useEffect(() => {
    if(txList){
      setAllPages([txList])
    }
  }, [txList]);


  const [hasMore, setHasMore] = useState(false)
  useEffect(() => {
    setHasMore(loadedPages < allPages.length)
  }, [loadedPages , allPages]);



  const filteredAndSortedData = useMemo(() => {
    let rows = [ ...allPages.slice(0, loadedPages+1).flat()]
    console.log(rows)
    console.log(txList)
    console.log(allPages)
    console.log(txQueryisSuccess)

    if (dateFromUTC && dateToUTC) {


      rows = rows.filter((r) => {
        const d = parseDateStr(r.dateTime)

        console.log(dateFromUTC, )
        console.log(dateToUTC)
        console.log(d)
        console.log( r.dateTime)

        return d >= dateFromUTC && d <= dateToUTC
      })


    }

    console.log(type)
    if (type) {
      console.log(JSON.stringify(rows))
      rows = rows.filter((r) => r.type === type)
      console.log(rows)
    }

    if (currency) {
      rows = rows.filter((r) => r.amount.includes(currency))
    }

    if (sort) {
      const dir = sort.direction === 'asc' ? 1 : -1

      rows.sort((a, b) => {
        switch (sort.columnId) {
          case 'dateTime': {
            return (parseDateStr(a.dateTime).getTime() - parseDateStr(b.dateTime).getTime()) * dir
          }
          case 'amount': {
            const extractNum = (s: string) => {
              const cleaned = s.replace(/[^0-9.\-−]/g, '').replace('−', '-')
              return parseFloat(cleaned) || 0
            }
            return (extractNum(a.amount) - extractNum(b.amount)) * dir
          }
          case 'type':
            return a.type.localeCompare(b.type) * dir
          case 'txHash':
            return a.txHash.localeCompare(b.txHash) * dir
          case 'status':
            return a.status.localeCompare(b.status) * dir
          default:
            return 0
        }
      })
    }

    return rows
  }, [dateFromUTC, dateToUTC, type, currency, sort, loadedPages,allPages])


  const handleDateRangeChange = (from: Date | undefined, to: Date | undefined) => {

    console.log(from, to)




    setDateFrom(from)
    setDateTo(to)


    if (to){
      const tu = new Date(Date.UTC(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59, 59));
      setDateToUTC(tu)

    }else{
      setDateToUTC(undefined)
    }
    if (from){
      const fu = new Date(Date.UTC(from.getFullYear(), from.getMonth(), from.getDate(), 0, 0, 0));
      setDateFromUTC(fu)
    }else{
      setDateFromUTC(undefined)
    }

  }

  const handleReset = () => {
    setDateFrom(undefined)
    setDateTo(undefined)
    setDateFromUTC(undefined)
    setDateToUTC(undefined)

    setType('')
    setCurrency('')
    setSort(null)
  }

  const handleRowClick = (row: TransactionRow) => {
    return () => {}
    // setSelectedTransaction(row)
  }

  const handleCloseModal = () => {
    setSelectedTransaction(null)
  }

  const handleLoadMore = () => {
    setLoadedPages((prev) => prev + 1)
  }

  const closeFilters = () => setShowFilters(false)

  return (
    <div className={stylesCommon.centerContainer}>
      <div className={styles.root}>
        {isMobile && (
          <div className={styles.mobileHeader}>
            <h2 className={styles.mobileTitle}>Transactions History</h2>
            <IconButton
              className={`${styles.filterButton} ${showFilters ? styles.filterButtonActive : ''}`}
              onClick={() => setShowFilters((v) => !v)}
              aria-label="Toggle filters"
            >
              <img src={filterFunnelIcon} alt="" className={styles.filterButtonIcon} />
            </IconButton>
          </div>
        )}

        <div className={styles.container}>
          {!isMobile && (
            <TransactionsFilters
              dateFrom={dateFrom}
              dateTo={dateTo}
              type={type}
              currency={currency}
              onDateRangeChange={handleDateRangeChange}
              onTypeChange={setType}
              onCurrencyChange={setCurrency}
              onReset={handleReset}
            />
          )}
          <TransactionsTable
            data={filteredAndSortedData}
            sort={sort}
            onSortChange={setSort}
            onRowClick={handleRowClick}
          />
          {hasMore && (
            <div className={styles.moreButtonWrapper}>
              <button className={styles.moreButton} onClick={handleLoadMore}>
                More
                <LuChevronDown className={styles.moreButtonIcon} />
              </button>
            </div>
          )}
        </div>
      </div>

      {isMobile && (
        <Drawer
          anchor="bottom"
          open={showFilters}
          onClose={closeFilters}
          slotProps={{
            paper: {className: styles.drawerPaper},
            backdrop: {className: styles.drawerBackdrop}
          }}
        >
          <div className={styles.drawerHandle} />
          <div className={styles.drawerHeader}>
            <span className={styles.drawerTitle}>Filters</span>
            <IconButton onClick={closeFilters} className={styles.drawerClose} aria-label="Close">
              <img src={xCloseIcon} alt="" className={styles.drawerCloseIcon} />
            </IconButton>
          </div>
          <div className={styles.drawerContent}>
            <TransactionsFilters
              dateFrom={dateFrom}
              dateTo={dateTo}
              type={type}
              currency={currency}
              onDateRangeChange={handleDateRangeChange}
              onTypeChange={setType}
              onCurrencyChange={setCurrency}
              onReset={handleReset}
              mobile
            />
          </div>
        </Drawer>
      )}

      <TransactionDetailsModal
        open={!!selectedTransaction}
        onClose={handleCloseModal}
        transaction={selectedTransaction}
      />
    </div>
  )
}
